import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  closeModal: () => void
  onConfirm: () => void
}

const FormModal = ({ closeModal, onConfirm }: Props) => {
  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('time_off.allowances.page.button.delete_tenure_period')}
      description={i18n.t('time_off.allowances.modal.tenure_period.delete_description')}
      onClose={closeModal}
      footer={
        <>
          <Button onClick={closeModal} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} type="negative">
            {i18n.t('common.destroy')}
          </Button>
        </>
      }
    />
  )
}

export default observer(FormModal)
